import { render, staticRenderFns } from "./index-layout.vue?vue&type=template&id=e6c44dec&"
import script from "./index-layout.vue?vue&type=script&lang=js&"
export * from "./index-layout.vue?vue&type=script&lang=js&"
import style0 from "./index-layout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports